import { TrashIcon, PencilIcon } from '@/components/icons'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

const SelectionList = ({ audiences, color, onRemove, isOpen, onEdit, selectedAudienceIdToEdit }) => {
    return (
        <div className="tw:flex tw:flex-col tw:border-t tw:border-b tw:divide-y">
            {audiences.map((audience) => (
                <div
                    className="tw:border-l-4 tw:hover:bg-gray-500 tw:flex tw:justify-between tw:group"
                    style={{ borderLeftColor: color }}
                    key={audience.id}
                >
                    <div 
                        className="tw:py-4 tw:px-5 tw:flex tw:gap-1.5 tw:items-center tw:justify-center tw:cursor-pointer"
                        onClick={() => onEdit(audience.id)}
                    >
                        <RadioGroup defaultValue="false">
                            <RadioGroupItem
                                value="true"
                                id="r2"
                                checked={selectedAudienceIdToEdit === audience.id}
                            />
                        </RadioGroup>
                        <span className="tw:text-sm tw:ml-1">{audience.name}</span>
                    </div>
                    <div className="tw:bg-gradient-to-r tw:from-transparent tw:to-primary-background tw:group-hover:block tw:hidden">
                        <div className="tw:pl-18 tw:flex tw:gap-4 tw:pr-5 tw:py-4">
                            <button onClick={() => onEdit(audience.id)} type="button">
                                <PencilIcon className="tw:size-5 tw:cursor-pointer tw:text-blue-300" />
                            </button>
                            <button onClick={() => onRemove(audience.id)} type="button">
                                <TrashIcon className="tw:size-5 tw:cursor-pointer tw:text-blue-300" />
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default SelectionList
